import { ulidToBytes, ulidBytesToHex } from '@w/utils'

const TRACE_ID_BYTES = 16 // 128 bits = 32 hex chars
const SPAN_ID_BYTES = 8 // 64 bits = 16 hex chars

/**
 * Convert ULID to 32-char hex string for OTEL traceId.
 * ULID = 19 chars → ulidToBytes gives 15 bytes + 1 length byte.
 * We strip the length byte and pad to 16 bytes.
 */
export function ulidToTraceId(ulid: string): string {
  const bytes = ulidToBytes(ulid)
  const dataBytes = bytes.slice(0, -1) // strip length byte

  const result = new Uint8Array(TRACE_ID_BYTES)
  const copyLen = Math.min(dataBytes.length, TRACE_ID_BYTES)
  result.set(dataBytes.slice(0, copyLen))

  return ulidBytesToHex(result)
}

/**
 * Convert ULID to 16-char hex string for OTEL spanId.
 * Takes last 8 bytes of ULID for uniqueness.
 */
export function ulidToSpanId(ulid: string): string {
  const bytes = ulidToBytes(ulid)
  const dataBytes = bytes.slice(0, -1) // strip length byte

  // Take last 8 bytes for span ID (more random part)
  const start = Math.max(0, dataBytes.length - SPAN_ID_BYTES)
  const result = new Uint8Array(SPAN_ID_BYTES)
  result.set(dataBytes.slice(start, start + SPAN_ID_BYTES))

  return ulidBytesToHex(result)
}
